<template>
  <ul class="radio-group">
    <li v-for="(title, itemValue) of values" :key="itemValue">
      <label :for="`${name}-${itemValue}`">
        <input
          type="radio"
          :name="name"
          :id="`${name}-${itemValue}`"
          :value="itemValue"
          :checked="itemValue === value"
          :required="required"
          @input="$emit('input', $event.target.value)"
          @click="$emit('input', $event.target.value)"
        />
        <span class="radio" />
        <span class="title">{{ title }}</span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    values: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped src="./radioGroup.css"></style>
